import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { getCookie } from '../utils/getCookies';
import { io } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

    socket: any;
    readonly url: string = environment.url; // Your Flask server URL
    isBrowser: boolean | undefined;

    constructor(@Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
        if (this.isBrowser) {
            // socket.io interprets any path on the URL as a namespace, so we
            // must split origin from path and pass the path via the `path` option.
            const parsedUrl = new URL(this.url);
            const origin = parsedUrl.origin;
            const basePath = parsedUrl.pathname.replace(/\/$/, '');
            const socketPath = `${basePath}/socket.io/`;

            this.socket = io(origin, {
                path: socketPath,
                transportOptions: {
                polling: {
                extraHeaders: {
                'Authorization': `Bearer ${getCookie('access_token')}`
                    }
                }
                },
                pingTimeout: 900000, // Add pingTimeout option
                pingInterval: 6000000 // Add pingInterval option
            } as any); // Cast to 'any' to bypass type checking

            this.socket.on('disconnect', function () {
                console.log('disconnect');
            });
        }
    }

    // ================ Job offer library ================

    // Listen for search results
    onJobOfferPreprocessing(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('job_offer_preprocessing', callback);
        }
    }

    onJobOfferPreprocessingCompleted(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('job_offer_preprocessing_completed', callback);
        }
    }

    // Emit a search event to the server
    SendJobOfferToPreprocess(searchData: any) {
      this.socket.emit('send_job_offer_to_preprocessing', searchData);
    }

    // ================ CV drive ================

    // Send CV to preprocessing
    sendCVToPreprocess(data: any) {
        this.socket.emit('send_cv_to_preprocessing', data);
    }

    // Listen for CV preprocessing completed
    onCVPreprocessingCompleted(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('cv_preprocessing_completed', callback);
        }
    }

    // Listen for CV preprocessing failed
    onCVPreprocessing(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('cv_preprocessing', callback);
        }
    }

    // ================ CV Deep Analyzer ================

    // Listen for CV Deep Analyzer preprocessing completed
    onCVDeepAnalyzerPreprocessingCompleted(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('get_analysis_rows_completed', callback);
        }
    }

    // Listen for CV Deep Analyzer preprocessing
    onCVDeepAnalyzerPreprocessing(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('get_analysis_row_in_progress', callback);
        }
    }

    // Listen for CV Deep Analyzer preprocessing
    onCVDeepAnalyzerFinalReport(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('onCVDeepAnalyzerFinalReport', callback);
        }
    }

    // Emit a event to the server to get the analysis rows
    updateNewAnalysis(data: any) {
        this.socket.emit('get_analysis_cv', data);
    }

    getAllAnalysisRows(data: any) {
        this.socket.emit('get_analysis_results', data);
    }

    // ================ Modal More Info ================
    onModalMoreInfo(callback: (data: any) => void) {
        if (this.isBrowser) {
            this.socket.on('onCVDeepAnalyzerMoreInformationReport', callback);
        }
    }

    emitModalMoreInfo(data: any) {
        this.socket.emit('generate_more_information_report', data);
    }
}
